import { EVENT_URI } from '../../../helpers/constants';

const hackList = {
  isScheduleDefaultList: ['digital1to1-winter-2023', 'tince23', 'digital1to1-italy-2023', 'digital1to1-travel-2023', 'retailluxurymbaforum', 'digital1to1-spring-2024', 'alpuraconave2024'],
  changeDefaultLiveNowIcon: ['tince23'],
  changeLiveNowDefaultTitle: ['tince23'],
  sortAttendeesByLastName: ['tince23'],
  skipAnalyticsTrackings: ['voannualnetworkmeeting2022', 'netwirkig'],
  hackedForOnClickActivityCard: ['investorsday', 'surainvestmentforum', '11forodeemisoras'],
  isPureBlackActivityCard: ['ss23', 'netwirkig', '22pro5', 'demo-juanortega'],
  loggedOutBgLayout: ['cbg'],
  hideInteractivitySection: ['netwirkig', 'pernodricardsaconference', 'journees-naturalite'],
  hideLiveNow: ['e-glm-2022', '22pro5', 'tdc-conference-nlc'],
  hideTabDailyStreaming: ['elearning-africa-primary-secondary-education', 'ettc2021', 'languages_and_the_media'],
};

const configs = {
  limitLocaleDropdownOptions:
    {
      '2022edition': ['en', 'tr'],
      networkingeventtia: ['en', 'es'],
      'demo-juanortega': ['en', 'es'],
    },
};

const useHack = (hackName) => hackList[hackName]?.includes(EVENT_URI);

export const useEventUriHackConfig = (hackName) => {
  const hackConfig = configs[hackName];

  return hackConfig?.[EVENT_URI];
};

export default useHack;
